import type React from 'react';

import { AdornedInput, Adornment, FormField, FormHelp, Label } from '@zillow/constellation';
import { CurrencyInput } from '@zillow/zrs-comet';

import type { Section } from '../../../../models';
import { CURRENCY_INPUT_PLACEHOLDER } from '../../../../constants/stringConstants';
import { SECURITY_DEPOSIT } from '../../../../constants';

type Props = {
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FormEvent<HTMLInputElement>) => void;
  dataTest?: string;
  section: Section;
  errorMessage?: string;
};

export default function SecurityDepositCurrencyInput({ section, dataTest, errorMessage, ...rest }: Props) {
  const field = section.getField(SECURITY_DEPOSIT.FIELD_NAME.AMOUNT);
  const value = section.getFieldValue(SECURITY_DEPOSIT.FIELD_NAME.AMOUNT);

  return (
    <FormField
      label={<Label>Security deposit</Label>}
      error={field.hasError}
      control={
        <AdornedInput
          input={
            <CurrencyInput value={value} data-test={dataTest} {...rest} placeholder={CURRENCY_INPUT_PLACEHOLDER} />
          }
          leftAdornment={<Adornment>$</Adornment>}
        />
      }
      description={<FormHelp>{field.hasError ? field.getErrorMessage() : errorMessage}</FormHelp>}
    />
  );
}
